import React from 'react';

/**
 * Standard width + horizontal padding + bottom spacing for authenticated app pages.
 * Sets .app-page for shared display typography (Bricolage Grotesque).
 *
 * @param {string} maxWidthClass — Tailwind max-width utility (default max-w-6xl).
 * @param {boolean} noXPad — Use minimal horizontal padding (e.g. full-bleed tables).
 */
export default function AppPageShell({
  children,
  className = '',
  maxWidthClass = 'max-w-6xl',
  noXPad = false,
}) {
  const xPad = noXPad ? 'px-0 sm:px-1' : 'px-4 sm:px-6 lg:px-8';
  return (
    <div
      className={`app-page w-full ${maxWidthClass} mx-auto ${xPad} pb-20 ${className}`.trim()}
    >
      {children}
    </div>
  );
}
